module.exports = __webpack_public_path__ + "static/media/SING-Ucd.9f04d70c.png";